export default {
    'menu.dashboard': 'Dashboard',
    'menu.systemManagement': 'System Management',
    'menu.accountManagement': 'Account Management',
    'menu.roleManagement': 'Roles',
};
